if (!customElements.get('cm-in-number-section')) {
  customElements.define(
    'cm-in-number-section',
    class CmInNumberSection extends HTMLElement {
      connectedCallback() {
        this.counters = this.querySelectorAll('[data-count-to]');

        if (!this.counters.length) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.setFinalValues();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.animateCounters();
              this.observer.disconnect();
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      setFinalValues() {
        this.counters.forEach((el) => {
          el.textContent = el.dataset.countTo;
        });
      }

      animateCounters() {
        const duration = 1500;

        this.counters.forEach((el) => {
          const target = parseFloat(el.dataset.countTo, 10);
          const decimals = (String(el.dataset.countTo).split('.')[1] || '').length;
          const startTime = performance.now();

          const step = (now) => {
            const progress = Math.min((now - startTime) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            const current = target * eased;

            el.textContent =
              decimals > 0 ? current.toFixed(decimals) : String(Math.round(current));

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.textContent =
                decimals > 0 ? target.toFixed(decimals) : String(Math.round(target));
            }
          };

          requestAnimationFrame(step);
        });
      }
    }
  );
}
